import { React, useEffect, useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { showLoader } from "@cisco/spaces-dash-lib-redux-store";
import HierarchyBase from "../hierarchy-base/hierarchy-base";
import { I18nContext } from "../../contexts/i18nContext";
import "../../common/common_style.scss";
import "../../common/global_style.scss";
import "./app.scss";

function App(props) {
  const i18n = useContext(I18nContext);
  const dispatch = useDispatch();
  const [showBaseComponent, setShowBaseComponent] = useState(false);

  useEffect(() => {
    console.log("Business Hierarchy App Mount");
    console.log(props);
    i18n.loadNamespaces("spaces-dash-app-business-hierarchy", (err, t) => {
      setShowBaseComponent(true);
      console.log(`${err} ${t}`);
      console.log("namespace loaded: ");
    });

    i18n.setDefaultNamespace("spaces-dash-app-business-hierarchy");

    return () => {
      dispatch(showLoader({ flag: false, loadingRef: "hierarchy" }));
    };
  }, []);

  return showBaseComponent && <HierarchyBase />;
}

export default App;
